import * as React from "react";
const TextFieldIcon = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.742 3.031h14.52a2.324 2.324 0 0 1 2.32 2.32v1.83a.24.24 0 0 1-.25.24.256.256 0 0 1-.25-.25V5.35a1.82 1.82 0 0 0-1.82-1.82H4.742a1.82 1.82 0 0 0-1.82 1.82v1.83c0 .134-.116.25-.25.25a.26.26 0 0 1-.25-.26V5.35a2.324 2.324 0 0 1 2.32-2.32Z"
            fill="#465050"
            stroke="#465050"
        />
        <path
            d="M12 21.47c-.41 0-.75-.34-.75-.75V4.11c0-.41.34-.75.75-.75s.75.34.75.75v16.61c0 .42-.34.75-.75.75"
            fill="#465050"
        />
        <path
            d="M15.94 21.469H8.06c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.88c.41 0 .75.34.75.75s-.34.75-.75.75"
            fill="#465050"
        />
    </svg>
);
export default TextFieldIcon;
